// src/components/InfoBanner.jsx
import "../index.css";

const SCHEDULE = {
  0: { open: [11, 30], close: [20, 0] },  // Sun 11:30–8:00
  1: null,                                 // Mon CLOSED
  2: { open: [11, 30], close: [20, 0] },  // Tue 11:30–8:00
  3: { open: [11, 30], close: [20, 0] },  // Wed 11:30–8:00
  4: { open: [11, 30], close: [20, 0] },  // Thu 11:30–8:00
  5: { open: [11, 30], close: [20, 30] }, // Fri 11:30–8:30
  6: { open: [11, 30], close: [20, 30] }, // Sat 11:30–8:30
};

function fmtTime([h, m]) {
  const period = h >= 12 ? "PM" : "AM";
  const hour12 = ((h + 11) % 12) + 1;
  const mm = String(m).padStart(2, "0");
  return `${hour12}:${mm} ${period}`;
}

export default function InfoBanner() {
  const day = new Date().getDay();
  const today = SCHEDULE[day];

  return (
    <div className="info-banner" role="note">
      <p className="info-text">
        Call to order:&nbsp;
        <a className="info-phone" href="tel:+13605888899">(360) 588-8899</a>
        <span className="sep">•</span>
        {today
          ? <>Open today {fmtTime(today.open)} – {fmtTime(today.close)}</>
          : <>Closed today</>}
      </p>
    </div>
  );
}
